<template>
  <div class="dati_warp">
    <div class="dati_bg">
      <div class="wrapper">
          <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "question"
}
</script>

<style scoped>
  .wrapper {
    padding: 0 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
</style>